module.exports = __webpack_public_path__ + "static/antigen-test-e2d7fde070c453e348c0ffc92ed8d164.png";